const siteMetaData = {
    title: "Vergo hub",
    description:
        "Vergo Hub gives you 24/7/365 online access to your pest control data, allowing you to manage your pest activity, actions, risk, reporting and more. Log in today!",
};

export default siteMetaData;
